import React from 'react'
import { Route, Redirect } from 'react-router-dom';
import { Service } from '../services';
import { Config } from '../config';
import { Layout } from '../views/Layout'

let checkAuth = false;

const Context = React.createContext();

const AuthConsumer = Context.Consumer;

class AuthProvider extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            authorized: false
        }

        this.onLogin = this.onLogin.bind(this);
        this.onLogout = this.onLogout.bind(this);
    }
    componentDidMount() {
        Service.User.Authenticated().then(response => {
            checkAuth = true;
            this.setState({
                authorized: response
            });
        });
    }
    onLogin(data) {

        Config.utilities.loadingAuth();

        Service.User.Xsrf().then(xsrf => {

            data.RequestVerificationToken = xsrf.token;

            Service.User.Login(data).then(response => {

                Config.utilities.loadingAuth();
    
                if (response && response.token) {
    
                    localStorage.removeItem('user');
                    localStorage.setItem('user', JSON.stringify(response));
    
                    this.setState({ authorized: true });
    
                } else {
                    this.setState({ authorized: false });
                }
            });

        });

    }
    onLogout(e) {
        e.preventDefault();

        Service.User.Logout();
        this.setState({ authorized: false });

    }
    render() {
        return (
            <Context.Provider
                value={{
                    authorized: this.state.authorized,
                    onLogin: this.onLogin,
                    onLogout: this.onLogout
                }} >
                {this.props.children}
            </Context.Provider>
        )
    }
}

const AuthRoute = ({ component: Component, ...rest }) => (
    <AuthConsumer>
        {({ authorized }) => (
            authorized ?
                <Route
                    render={props =>
                        <Layout topbar="true" footer="true" sidebar="true">
                            <Component {...props} />
                        </Layout>
                    }
                    {...rest}
                />
                :
                (checkAuth === false) ? 
                    ""
                    :
                    <Redirect to="/login" />
        )}
    </AuthConsumer>
);

export { AuthConsumer, AuthProvider, AuthRoute }